import { useState } from 'react';

export const useHover = (initialState = false) => {
  const [isHovering, setHovering] = useState(initialState);

  const setHover = state => () => setHovering(state);

  return [isHovering, setHover];
};
